import React, {useState} from 'react';
import {Collapse} from "react-bootstrap";
import {ReactComponent as ArrowDownIco} from "../../../../../../../../images/icons/arrow-bottom.svg";
import {ReactComponent as ArrowUpIco} from "../../../../../../../../images/icons/arrow-top.svg";
import ProductModifierGroupSingleSelectOption from "./ProductModifierGroupSingleSelectOption";
import StateItemHelper from "../../../../../../../services/Menu/services/State/StateItemHelper";
import {RootState} from "../../../../../../../../reducers";
import {getItems, getModifierGroups} from "../../../../../../../services/Menu/reducer";
import {getSession} from "../../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import MenuEditItemViewHelper from "../../../../../../../services/Menu/services/ItemView/MenuEditItemViewHelper";
import ProductModifierGroupQuantityInfo from "../ProductModifierGroupQuantityInfo";

interface OwnProps {
    modifierGroup: Record<string, any>;
    updateProductState: (productState: Record<string, any>) => void;
    productState: Record<string, any>;
    isProductAvailable: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const ProductModifierGroupSingleSelect = ({
                                              modifierGroup,
                                              isProductAvailable,
                                              updateProductState,
                                              productState,
                                              session,
                                              modifierGroups,
                                              items
                                          }: Props) => {
    const [showItems, setShowItems] = useState(true);

    const getFilteredOptions = () => {
        return modifierGroup.options
            .map((option: Record<string, any>) => {
                return MenuEditItemViewHelper.parseOptionForIncludedQuantity(option);
            })
            .filter((option: Record<string, any>, index: number, array: Record<string, any>[]) => {
                return option.max_permitted !== 0 && !option.only_included_and_cannot_modify && array.findIndex((arrayItem) => arrayItem.id === option.id) === index;
            });
    }

    if (getFilteredOptions().length === 0 || (getFilteredOptions().length === 1 && getFilteredOptions()[0].min_permitted && getFilteredOptions()[0].min_permitted === getFilteredOptions()[0].default_quantity)) return <></>;

    if (modifierGroup.options.some((option: Record<string, any>) => option.min_permitted === 1 && option.min_permitted === option.default_quantity)) return <></>;

    const changeOptionQuantity = (option: Record<string, any>) => {
        const newProductState = JSON.parse(JSON.stringify(productState));
        StateItemHelper.setQuantityItem(newProductState, modifierGroup, option, 1, items, modifierGroups, session.order_type)
        updateProductState(newProductState);
    };

    const getPriceDisplayMode = () => {
        const anyFreeItem = modifierGroup.options.some((option: Record<string, any>) => !option.price);
        const anyNotFreeItem = modifierGroup.options.some((option: Record<string, any>) => option.price);

        if (anyFreeItem && anyNotFreeItem) return "mixed";

        if (anyFreeItem || !anyNotFreeItem) return "allFree";

        if (!anyFreeItem || anyNotFreeItem) return "allPaid";
    }

    return (
        <fieldset className="form-group">
            <legend aria-live="polite">
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <h5>
                        {modifierGroup.name}
                    </h5>
                    {
                        showItems ? <ArrowUpIco className="collapse-icon" onClick={() => setShowItems(false)}/> :
                            <ArrowDownIco className="collapse-icon" onClick={() => setShowItems(true)}/>
                    }
                </div>
                <ProductModifierGroupQuantityInfo
                    hideBadge={isProductAvailable ? undefined : true}
                    quantity={modifierGroup.adapted_quantity}
                    quantityInfo={{
                        minPermitted: modifierGroup.adapted_min_permitted,
                        maxPermitted: modifierGroup.adapted_max_permitted,
                        chargeAbove: modifierGroup.adapted_charge_above
                    }}/>
            </legend>
            <Collapse in={showItems}>
                <div>
                    <div className="product-items-grid">
                        {[...getFilteredOptions()].sort((a: Record<string, any>, b: Record<string, any>) => a.position - b.position || a.name.localeCompare(b.name))
                            .map((option: Record<string, any>) => (
                                <ProductModifierGroupSingleSelectOption key={`${modifierGroup.id}-${option.id}`}
                                                                        option={option} modifierGroup={modifierGroup}
                                                                        changeQuantity={changeOptionQuantity}
                                                                        priceDisplayMode={getPriceDisplayMode()}
                                                                        isProductAvailable={isProductAvailable}/>
                            ))}
                    </div>
                </div>
            </Collapse>
        </fieldset>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    modifierGroups: getModifierGroups(state.menu),
    session: getSession(state.session),
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(ProductModifierGroupSingleSelect));
